/**
 * エラー文言
 */
export const ERR_LICENSE = "ライセンスが無効です。シリアルコードを確認して下さい。(x)";
export const ERR_LICENSE_MOBILE = "ライセンスが無効です。(x)";
export const ERR_NETWORK = "サーバーへの接続が失敗しました。インターネットの接続を確認して再度お試しください。";
export const ERR_INVALID_USER = "メールアドレスまたは、パスワードが正しくありません。";
export const ERR_USER_LOCKED = "アカウントが無効です。別のアカウントでログインしてください。";
export const ERR_INVALID_SERIAL = "シリアル番号が正しくありません。";
export const ERR_ONETIMEKEY = "ワンタイムキーが無効です。再度ログインして下さい。(x)";
export const ERR_UNKNOWN = "現在、サービスを利用できません。";
export const ERR_SRE = "音声機能を有効にできませんでした。";
export const ERR_TAKEOVER_PASSWORD = "英数半角4～16文字で入力して下さい。";
export const ERR_INVALID_TAKEOVER = "引継ぎコードまたは、パスワードが正しくありません。";

/**
 * 画面表示用文言
 */
export const BUTTON_TEXT_LESSON = "レッスンを続ける";
export const BUTTON_TEXT_LEVEL = "レベル0を今すぐ開始";
export const LESSON_STATE = "進行中";

/**
 * key-value設定API用のkey名
 */
export const DATA_SETTING = "data-setting-";
export const DATA_SCORE = "data-score-";
export const DATA_PROGRESS = "data-progress-";
export const DATA_STUDY_STATE = "data-study-state";
export const DATA_REVISION = "data-revision-";
export const DATA_PATHSTEP_LENGTH = "data-pathstep-length-";
export const DATA_PATHSTEP_CHALLENGE = "data-pathstep-challenge-";

export const DATA_SETTING_SRE_USE = "data-setting-sreUse";
export const DATA_SETTING_GENDER = "data-setting-gender";
export const DATA_SETTING_DIFFICULTY = "data-setting-difficulty";
export const DATA_SETTING_AUTO_SCREEN_TRANSITION = "data-setting-autoScreenTransition";
export const DATA_SETTING_ANSWER_SOUND = "data-setting-answerSound";
export const DATA_SETTING_SCRIPTTYPE = "data-setting-scriptType";
/* 中国語ピンイン表記 */
export const DATA_SETTING_DISPLAYMODE = "data-setting-displayMode";
// 学習済グループ接頭辞
export const DATA_LEARNED_GROUP = "data-learned-group-";
export const DATA_SETTING_TEXT_SIZE = "data-setting-textSize";
export const DATA_SETTING_POPUP_DICTIONARY_USE = "data-setting-popupDictionaryUse";

/**
 * Error.vueのbuttonKind
 */
export const ERROR_BUTTON_KIND_LOGIN = "login";
export const ERROR_BUTTON_KIND_SERIAL = "serial";
export const ERROR_BUTTON_KIND_LICENSE = "checklicense";
export const ERROR_BUTTON_KIND_LIBRARY = "library";
export const ERROR_BUTTON_KIND_ACCESSKEY = "getaccesskey";
export const ERROR_BUTTON_KIND_CLOSE = "close";

/**
 * ファイルパス
 */
export const AUDIO_CORRECT = "./static/resource/sound/correct.mp3"; //正解音
export const AUDIO_INCORRECT = "./static/resource/sound/incorrect.mp3"; //不正解音
export const AUDIO_RECOGNITION = "./static/resource/sound/speechPrompt.mp3"; //音声認識再生音
export const AUDIO_MASK = "./static/resource/sound/tileSound.mp3"; //マスク音

/**
 * runmode名
 */
export const RUNMODE_A1 = "A1";
export const RUNMODE_A1O = "A1O";
export const RUNMODE_FAD = "FAD";
export const RUNMODE_B = "B1";
export const RUNMODE_BO = "B1O";
export const RUNMODE_C1 = "C1";
export const RUNMODE_C1O = "C1O";
export const RUNMODE_A4 = "A4";
export const RUNMODE_A4O = "A4O";
export const RUNMODE_A1Q = "A1Q";
export const RUNMODE_B1Q = "B1Q";
export const RUNMODE_C1Q = "C1Q";
export const RUNMODE_A3 = "A3";
export const RUNMODE_A3O = "A3O";
export const RUNMODE_C3 = "C3";
export const RUNMODE_C3O = "C3O";
export const RUNMODE_A3Q = "A3Q";
export const RUNMODE_ThreeTwoOne = "ThreeTwoOne";
export const RUNMODE_TwoTwo = "TwoTwo";
export const RUNMODE_TILE = "Tile";
export const RUNMODE_STILE = "STile";
export const RUNMODE_LTILE = "LetterTile";
export const RUNMODE_P = "P";
export const RUNMODE_PNT = "PNT";
export const RUNMODE_PNS = "PNS";
export const RUNMODE_PSPEECH = "PSpeech";
export const RUNMODE_PNTSPEECH = "PNTSpeech";
export const RUNMODE_SPEECH = "Speech";
export const RUNMODE_MILESTONE = "Milestone";

/**
 * SREを使用しないrunmode一覧
 */
export const RUNMODE_NOT_USE_SRE = [
  RUNMODE_A1,
  RUNMODE_A1O,
  RUNMODE_FAD,
  RUNMODE_B,
  RUNMODE_BO,
  RUNMODE_C1,
  RUNMODE_C1O,
  RUNMODE_A4,
  RUNMODE_A4O,
  RUNMODE_A1Q,
  RUNMODE_B1Q,
  RUNMODE_C1Q,
  RUNMODE_A3,
  RUNMODE_A3O,
  RUNMODE_C3,
  RUNMODE_C3O,
  RUNMODE_A3Q,
  RUNMODE_ThreeTwoOne,
  RUNMODE_TwoTwo,
  RUNMODE_TILE,
  RUNMODE_STILE,
  RUNMODE_LTILE
];

/**
/* 処理間隔（ミリ数）
 */
// 問題の出題間隔
export const QUESTION_INTERVAL = 500;
// 不正解画像の表示時間
export const INCORRECT_INTERVAL = 1000;
// 全問正解時の表示時間
export const ALLCORRECT_INTERVAL = 3000;
// ロングタッチの間隔
export const LONGTOUCH_DURATION = 500;
// スクロールアイコン表示タイムアウト
export const SCROLL_ICON_VISIBLE_TIME = 5000;

/**
 * 正解判定score
 */
export const CORRECT_SCORE = 7;

/**
 * 表示するテキスト言語
 */
export const BASIC_TEXT = "basicText";
export const JAPANESE_TEXT = "japaneseText";

/**
 * 表示形式のID
 */
export const TEXT_SCRIPTID_PRIMARY = "Primary";
// 中国語
export const TEXT_SCRIPTID_SIMPLIFIED = "Simplified";
export const TEXT_SCRIPTID_TRADITIONAL = "Traditional";
export const TEXT_SCRIPTID_PINYIN = "Pinyin";
// アラビア語
export const TEXT_SCRIPTID_LIGHTLY_ACCENTED = "Lightly Accented";
export const TEXT_SCRIPTID_FULLY_ACCENTED = "Fully Accented";
// オランダ語
export const TEXT_SCRIPTID_DUTCH = "Dutch";
// ヘブライ語
export const TEXT_SCRIPTID_VOWELED = "Voweled";
export const TEXT_SCRIPTID_UNVOWELED = "Unvoweled";
// ペルシア語(ファルシ語)
export const TEXT_SCRIPTID_ACCENTED = "Accented";
export const TEXT_SCRIPTID_NON_ACCENTED = "Non-Accented";
// 日本語
export const TEXT_SCRIPTID_KANJI = "Kanji";
export const TEXT_SCRIPTID_KANA = "Kana";
export const TEXT_SCRIPTID_ROMAJI = "Romaji";
export const TEXT_SCRIPTID_HIRAGANA = "Hiragana";
export const TEXT_SCRIPTID_KATAKANA = "Katakana";

/**
 * カーソルタイプ
 */
// 矢印マーク
export const CURSOR_DEFAULT = "default";
// 指マーク
export const CURSOR_POINTER = "pointer";

/**
 * プラットフォーム名
 */
// Android
export const PLATFORM_ANDROID = "android";

/**
 * パッケージ名
 */
// ドコモ版Android(先頭から本番/ステージング別共通部分まで)
export const PACKAGE_DOCOMO_ANDROID = "com.sourcenext.android.docomo.rosettastone.basic";
// au版Android(先頭から本番/ステージング別言語別共通部分まで)
export const PACKAGE_AU_ANDROID = "com.sourcenext.android.kddi.rosettastone.";
// softbank版Android(先頭から本番/ステージング別言語別共通部分まで)
export const PACKAGE_SOFTBANK_ANDROID = "com.mobiroo.n.sourcenextcorporation.rosetta_";

/**
 * モバイルアプリの最新version
 * アップデート通知ダイアログの表示判定に使用
 */
 // au版Android
 export const VERSION_AU_ANDROID = 14;
 // softbank版Android
 export const VERSION_SOFTBANK_ANDROID = 18;

/**
 * HTML5で動作するSafariのメジャーバージョン
 */
export const SAFARI_HTML5_VERSION = 11;

/**
 * pathタイトル
 */
export const PATH_TITLE_REVIEW = "復習";
export const PATH_TITLE_MILESTONE = "マイルストーン";

/**
 * 言語コード
 */
// 英語(アメリカ)
export const LANGUAGE_CODE_ENUS = "en-US";
// 英語（イギリス）
export const LANGUAGE_CODE_ENGB = "en-GB";
// 中国語（マンダリン)
export const LANGUAGE_CODE_ZHCV = "zh-CN";
// ドイツ語
export const LANGUAGE_CODE_DEDE = "de-DE";
// フランス語
export const LANGUAGE_CODE_FRFR = "fr-FR";
// イタリア語
export const LANGUAGE_CODE_ITIT = "it-IT";
// ベトナム語
export const LANGUAGE_CODE_VIVN = "vi-VN";
// 韓国語
export const LANGUAGE_CODE_KOKR = "ko-KR";
// スペイン語（スペイン）
export const LANGUAGE_CODE_ESES = "es-ES";
// スペイン語（ラテンアメリカ）
export const LANGUAGE_CODE_ES419 = "es-419";
// アラビア語
export const LANGUAGE_CODE_AR = "ar";
// ロシア語
export const LANGUAGE_CODE_RURU = "ru-RU";
// ヒンディー語
export const LANGUAGE_CODE_HIIN = "hi-IN";
// フィリピン語（タガログ語）
export const LANGUAGE_CODE_TLPH = "tl-PH";
// トルコ語
export const LANGUAGE_CODE_TRTR = "tr-TR";
// スウェーデン語
export const LANGUAGE_CODE_SVSE = "sv-SE";
// 日本語
export const LANGUAGE_CODE_JAJP = "ja-JP";
// ポーランド語
export const LANGUAGE_CODE_PLPL = "pl-PL";
// ポルトガル語（ブラジル）
export const LANGUAGE_CODE_PTBR = "pt-BR";
// ヘブライ語
export const LANGUAGE_CODE_HEIL = "he-IL";
// ギリシャ語
export const LANGUAGE_CODE_ELGR = "el-GR";
// オランダ語
export const LANGUAGE_CODE_NLNL = "nl-NL";
// アイルランド語
export const LANGUAGE_CODE_GAIE = "ga-IE";
// ペルシア語（ファルシ語）
export const LANGUAGE_CODE_FAIR = "fa-IR";

/**
 * 中国語表記の値
 */
export const SCRIPT_TYPE_SETTING_KAN = "Simplified";
export const SCRIPT_TYPE_SETTING_HAN = "Traditional";
export const SCRIPT_TYPE_LIST = [
  SCRIPT_TYPE_SETTING_KAN,
  SCRIPT_TYPE_SETTING_HAN
];

/**
 * 表示モード
 */
export const DISPLAY_MODE_WITH_PINYIN = "withPinyin";
export const DISPLAY_MODE_NO_PINYIN = "noPinyin";
export const DISPLAY_MODE_PINYIN_ONLY = "pinyinOnly";
export const DISPLAY_MODE_UNVOWELED = "unvoweled";
export const DISPLAY_MODE_VOWELED = "voweled";
export const DISPLAY_MODE_KANJI_WITH_KANA = "kanjiWithKana";
export const DISPLAY_MODE_KANJI = "kanji";
export const DISPLAY_MODE_KANA = "kana";
export const DISPLAY_MODE_ROMAJI = "romaji";
export const DISPLAY_MODE_NONE = "none";

/**
 * modeGroup
 */
export const MODE_GROUP_ACT_CHOICE = "actChoice";
export const MODE_GROUP_CUE_CHOICE = "cueChoice";
export const MODE_GROUP_TILE = "tile";
export const MODE_GROUP_SPEECH = "speech";
export const MODE_GROUP_MILESTONE = "milestone";

export const DATA_LEARNED_GROUP_LIST = [
  MODE_GROUP_ACT_CHOICE,
  MODE_GROUP_CUE_CHOICE,
  MODE_GROUP_TILE,
  MODE_GROUP_SPEECH,
  MODE_GROUP_MILESTONE
];

/**
 * ヒントダイアログ
 */
// マウスドラッグ可能範囲(px)
export const HINT_DIALOG_MOUSE_DRUG_AREA = 10;

/**
 * vueの名前
 */
export const VUE_NAME_RUNMODE = "runmode";
export const VUE_NAME_TOOLBAR = "toolbar";
export const VUE_NAME_COMMONACT = "CommonAct";

/**
 * 拡大時の表示倍率
 */
export const DISP_MAGNIFICATION_PC = 2.0;
export const DISP_MAGNIFICATION_MOBILE = 1.3;

/**
 * テキストの縮小率
 */
export const SHRINK_FONT_KANJI_WITH_KANA = 0.7;

/**
 * Path表示順
 */
export const PATH_ORDER = [
  "general",
  "pronunciation",
  "vocabulary",
  "grammar",
  "listening_and_reading",
  "reading",
  "writing",
  "listening",
  "speaking",
  "review"
];

/**
 * ポップアップ辞書設定
 */
export const POPUP_DICTIONARY_SETTINGS = {
  isProdution: process.env.DEPLOY_ENV === "production",
  popupSpeed: 500,
  showSetting: true
};

/**
 * ポップアップ辞書表示対象言語のリスト
 * ※ポップアップ辞書機能クローズのため、現在は空の配列を設定
 */
export const POPUP_DICTIONARY_LANGUAGE_LIST = [];

/**
 * テキスト表示設定
 */
export const MAX_LINE_NUMBER = 5;
export const MAX_IMAGE_TEXT_FONT_SIZE = 50;
export const AUTO_ADJUST_FONT_SIZE = {
  large: {
    min: 14,
    mid: 20,
    max: 26
  },
  middle: {
    min: 14,
    mid: 18,
    max: 20
  },
  small: {
    min: 11,
    mid: 14,
    max: 16
  }
};

/**
 * GoogleAnalyticsイベントフィールド設定値
 */
export const GA_EVENT = Object.freeze({
  GATEGORY: Object.freeze({
    WORD_LIST: "単語リスト"
  }),
  ACTION: Object.freeze({
    CLICK: "押下"
  }),
  LABEL: Object.freeze({
    DICTIONARY: "辞書"
  })
});

/**
 * GoogleAnalyticsページビューの設定値（ポップアップ辞書表示）
 */
export const GA_PAGEVIEW_TITLE = "ポップアップ辞書";
export const GA_PAGEVIEW_PAGE = "/popup";



// WEBPACK FOOTER //
// ./src/mixin/constants.js